module.exports = __webpack_public_path__ + "static/media/vote-nay.c57e0122.svg";